import React from 'react'
import { Modal, Button, Typography, Box, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { mono, boFont } from '@components/systems/backoffice/backoffice.tokens'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'

interface SeasonDeleteConfirmationModalProps {
	open: boolean
	onClose: () => void
	onDelete: () => void
	seasonTitle: string
}

export const SeasonDeleteConfirmationModal: React.FC<
	SeasonDeleteConfirmationModalProps
> = ({ open, onClose, onDelete, seasonTitle }) => {
	return (
		<Modal
			open={open}
			onClose={onClose}
			aria-labelledby="delete-confirmation-title"
			aria-describedby="delete-confirmation-description"
		>
			<Box component="div" sx={styles.modalContent}>
				<IconButton onClick={onClose} sx={styles.closeButton} aria-label="close">
					<CloseIcon />
				</IconButton>
				<DeleteOutlineIcon sx={styles.icon} />
				<Typography
					id="delete-confirmation-title"
					variant="h6"
					component="h2"
					sx={styles.title}
				>
					시즌 삭제 확인
				</Typography>
				<Typography
					id="delete-confirmation-description"
					variant="body1"
					sx={styles.description}
				>
					정말로 <strong>{seasonTitle}</strong> 시즌을 삭제하시겠습니까?
				</Typography>
				<Typography variant="body2" color="text.secondary" sx={styles.warning}>
					이 작업은 되돌릴 수 없으며, 관련된 모든 데이터가 삭제됩니다.
				</Typography>
				<Box sx={styles.buttonContainer}>
					<Button variant="text" onClick={onClose} sx={styles.cancelButton}>
						취소
					</Button>
					<Button variant="outlined" onClick={onDelete} sx={styles.deleteButton}>
						삭제하기
					</Button>
				</Box>
			</Box>
		</Modal>
	)
}

const styles = {
	modalContent: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: '400px',
		maxWidth: 'calc(100vw - 32px)',
		backgroundColor: mono.surface,
		border: `1px solid ${mono.line}`,
		boxShadow: '0 30px 60px rgba(20, 24, 32, 0.12)',
		padding: '32px',
		borderRadius: 0,
		textAlign: 'left',
		fontFamily: boFont.ui,
		outline: 'none',
	},
	closeButton: {
		position: 'absolute',
		right: '8px',
		top: '8px',
	},
	icon: {
		fontSize: '28px',
		color: mono.dim,
		marginBottom: '16px',
	},
	title: {
		marginBottom: '12px',
		fontSize: 18,
		fontWeight: 400,
		color: mono.ink,
	},
	description: {
		marginBottom: '8px',
		fontSize: 14,
		fontWeight: 300,
		color: mono.ink,
		lineHeight: 1.6,
	},
	warning: {
		marginBottom: '24px',
		fontSize: 13,
		fontWeight: 300,
		color: mono.dim,
		lineHeight: 1.6,
	},
	buttonContainer: {
		display: 'flex',
		justifyContent: 'flex-end',
		gap: '8px',
		paddingTop: '16px',
		borderTop: `1px solid ${mono.line}`,
	},
	cancelButton: {
		minWidth: '80px',
	},
	confirmButton: {
		minWidth: '100px',
	},
	deleteButton: {
		minWidth: '100px',
	},
}
